<template>
  <div class="fc-form-signin-wrapper">
    <form class="fc-form-signin">
      <div class="mb-5 text-center">
        <img src="/static/logo_FC_2_svg.svg" alt width="240" />
      </div>

      <label for="inputEmail" class>{{ $i18n.t("login.label_mailaddress") }}</label>
      <b-form-input id="inputEmail" v-model="inputEmail" type="text" placeholder="Mailaddress" class="mb-3" maxlength="100" @keydown.enter="$refs.refPassword.focus()"></b-form-input>

      <label for="inputPassword" class>{{ $i18n.t("login.label_password") }}</label>
      <b-form-input id="inputPassword" v-model="inputPassword" ref="refPassword" type="password" placeholder="Password" class="mb-3" maxlength="100" @keydown.enter="login"></b-form-input>

      <b-form-select v-model="selectedLang" :options="langList" class="mb-3" @input="changeLanguage"></b-form-select>

      <b-button block size="lg" variant="primary" class="my-3" @click="login">{{ $i18n.t("login.button_login") }}</b-button>

      <!-- <b-form-checkbox value="remember-me" class="my-3">{{ $i18n.t("login.info_login_save") }}</b-form-checkbox> -->

      <div class="mt-5 small text-center">
        <div class="my-3">
          <u>
            <b-link @click="showForgotPass" href>{{ $i18n.t("login.forgot_password") }}</b-link>
          </u>
        </div>
        <!--
          <div class="my-3">
          <b-link href>{{ $i18n.t("login.forgot_login") }}</b-link>
        </div>
        -->
      </div>
      <p class="mt-5 mb-3 text-muted text-center">&copy; 2020 Japan Novel Corporation</p>
    </form>
    <ForgotPassModal modId="md-forgotPass" @confirm="sendMail"/>
    <confirmModal modId="md-err" :msg="errMsg" :titleMsg="errSbj" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="errConfirm"/>
    <confirmModal modId="md-err-forgot" :msg="errMsg" :titleMsg="errSbj" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="showForgotPass"/>
    <confirmModal modId="md-confirm" :msg="this.$i18n.t('login.send_password')" :titleMsg="this.$i18n.t('login.forgot_password_title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="registConfirm"/>
    <Loading />
  </div>
</template>

<script>
import confirmModal from './ConfirmModal'
import ForgotPassModal from './ForgotPassModal'
import Loading from './Loading'
export default {
  components: {
    confirmModal,
    ForgotPassModal,
    Loading
  },
  data () {
    return {
      selectedLang: 'ja-jp',
      langList: [
        { value: 'ja-jp', text: '日本語' },
        { value: 'en-us', text: 'English' },
        { value: 'zh-CN', text: '簡体字' },
        { value: 'zh-TW', text: '繁体字' }
      ],
      errMsg: '',
      errSbj: '',
      inputEmailForReessue: '',
      modalResult: false
    }
  },
  beforeCreated () {
    if (this.$store.store.state.language !== '') {
      this.selectedLang = this.$store.store.getters.getLang
      this.$i18n.locale = this.selectedLang
    }
  },
  created () {
    this.$store.store.state.loading = false
    document.body.style.overflow = 'auto'
    if (this.$store.store.state.language !== '') {
      this.selectedLang = this.$store.store.getters.getLang
    } else {
      this.selectedlang = 'ja-jp'
      this.$store.store.dispatch('setLang', this.selectedLang)
    }
  },
  methods: {
    changeLanguage: function () {
      // this.$store.store.state.auth.token = this.selectedLang
      this.$store.store.dispatch('setLang', this.selectedLang)
      this.$i18n.locale = this.selectedLang
    },
    showForgotPass: function () {
      this.$bvModal.hide('md-err-forgot')
      this.$bvModal.show('md-forgotPass')
    },
    login: function () {
      if (this.inputEmail === null || this.inputEmail === '' || this.inputEmail === undefined) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('login.err_user_hissu')
        this.$bvModal.show('md-err')
        return
      }

      // メールアドレス形式チェック
      if (!window.checkMail(this.inputEmail)) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('login.err_not_mail')
        this.$bvModal.show('md-err')
        return
      }

      if (this.inputPassword === null || this.inputPassword === '' || this.inputPassword === undefined) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('login.err_pass_hissu')
        this.$bvModal.show('md-err')
        return
      }

      if (this.$i18n.locale === null || this.$i18n.locale === '' || this.$i18n.locale === undefined) {
        // 言語は空欄に出来ないためひっかからないはず
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('login.err_lang_hissu')
        this.$bvModal.show('md-err')
        return
      }

      var reqObj = {}
      reqObj.userid = this.inputEmail
      reqObj.password = this.inputPassword

      var headers = {
        'Content-Type': 'application/json'
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/common/login', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          if (res.data.result !== 'OK') {
            this.errSbj = this.$i18n.t('common.title_modal_error')
            this.errMsg = this.$i18n.t(res.data.message)
            this.$bvModal.show('md-err')
          } else {
            this.$store.store.state.opId = res.data.opId
            this.$store.store.state.ticketId = res.data.ticketId
            this.$store.store.state.userName = res.data.userName
            this.$store.store.state.menuList = res.data.menuid

            if (res.data.auth === 0) {
              this.$router.push('register')
            } else {
              this.$router.push('top')
            }
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    errConfirm: function () {
      this.$bvModal.hide('md-err')
      this.errMsg = ''
      this.errSbj = ''
    },
    sendMail: function () {
      this.$bvModal.hide('md-forgotPass')
      if (this.modalResult) {
        if (this.inputEmailForReessue === null || this.inputEmailForReessue === '' || this.inputEmailForReessue === undefined) {
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('login.err_no_mailaddress')
          this.$bvModal.show('md-err-forgot')
          return
        }

        // メールアドレス形式チェック
        if (!window.checkMail(this.inputEmailForReessue)) {
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('login.err_not_mail')
          this.$bvModal.show('md-err-forgot')
          return
        }

        // リクエスト
        var reqObj = {}
        reqObj.userid = this.inputEmailForReessue

        var headers = {
          'Content-Type': 'application/json'
        }
        document.body.style.overflow = 'hidden'
        this.$store.store.state.loading = true
        this.$axios
          .post(window.END_POINT + '/common/forgotPass', reqObj, {
            'headers': headers
          })
          .then(res => {
            this.$store.store.state.loading = false
            document.body.style.overflow = 'auto'
            if (res.data.result !== 'OK') {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err-forgot')
            } else {
              this.$bvModal.show('md-confirm')
              this.$bvModal.hide('md-forgotPass')
            }
          })
          .catch(err => {
            console.log(err)
            this.errSbj = this.$i18n.t('common.title_modal_error')
            this.errMsg = this.$i18n.t('common.unexpected_error')
            this.$bvModal.show('md-err-forgot')
          })
      }
    },
    registConfirm: function () {
      this.$bvModal.hide('md-confirm')
      this.inputEmailForReessue = ''
    }
  }
}
</script>

<style scoped>
.fc-form-signin-wrapper {
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #52575c;
}

.fc-form-signin {
  width: 30rem;
  margin: auto;
  padding: 3rem;
  background-color: #272b30;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue